// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4223":"883c0095","6722":"c7d6b1cd","6808":"27e50db9","7254":"000d42e0"}[chunkId] + ".chunk.css";
};